import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface User {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'designer' | 'client';
  projects?: string[];
  subscriptionTier?: 'unlimited' | 'two_projects' | 'one_project';
}

interface AuthState {
  user: User | null;
  token: string | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{ user: User; token: string }>
    ) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    logoutSuccess: (state) => {
      state.user = null;
      state.token = null;
    },
  },
});

export const { setCredentials, logoutSuccess } = authSlice.actions;
export default authSlice.reducer;
